import { Interview } from "../models/Interview";
import { FeedbackStatus } from "../models/FeedbackStatus";
import "./feedbackstatuses.css";
import { Loader, Paper, Text, useMantineTheme } from "@mantine/core";

interface FeedbackStatusComponentProps {
  feedbackLoading: boolean;
  interview: Interview;
  feedbackStatuses: FeedbackStatus[];
}

const FeedbackStatusComponent = ({
  feedbackLoading,
  interview,
  feedbackStatuses,
}: FeedbackStatusComponentProps) => {
  const theme = useMantineTheme();

  const matchFeedbackStatus = (interview: Interview) => {
    return feedbackStatuses.find(
      (item) => item.interviewId === interview.interviewId,
    )?.status;
  };

  const renderFeedbackStatus = (interview: Interview) => {
    const feedbackStatus = matchFeedbackStatus(interview);

    if (feedbackStatus === "not started") {
      return (
        <Paper shadow="xs" p="xs" bg={theme.colors.red[1]}>
          <Text size="sm" c={theme.colors.red[6]}>
            Not Started
          </Text>
        </Paper>
      );
    } else {
      return (
        <Paper shadow="xs" p="xs" bg={theme.colors.yellow[0]}>
          <Text size="sm" c={theme.colors.orange[6]}>
            In Progress
          </Text>
        </Paper>
      );
    }
  };

  if (feedbackLoading) {
    return <Loader />;
  }

  if (interview.feedbackSubmitted) {
    return (
      <>
        <Paper shadow="xs" p="xs" bg={theme.colors.green[0]}>
          <Text size="sm" c={theme.colors.green[6]}>
            Submitted
          </Text>
        </Paper>
      </>
    );
  }

  return renderFeedbackStatus(interview);
};

export default FeedbackStatusComponent;
